import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //web前端
    {
      path: '/',
      component: resolve => require(['../components/index'], resolve)
    },
    {
      path: '/index',
      component: resolve => require(['../components/index'], resolve)
    },
    {
      path: '/about',
      component: resolve => require(['../components/about'], resolve)
    },
    {
      path: '/fund',
      component: resolve => require(['../components/fund'], resolve)
    },
    {
      path: '/healthy-fund',
      component: resolve => require(['../components/healthy-fund'], resolve)
    },
    {
      path: '/job',
      component: resolve => require(['../components/job'], resolve)
    },
    {
      path: '/news',
      component: resolve => require(['../components/news'], resolve)
    },
    {
      path: '/news-info',
      component: resolve => require(['../components/news-info'], resolve)
    },
    //后台
    {
      path: '/login',
      component: resolve => require(['../components/login'], resolve)
    },
    {
      path: '/news-add',
      component: resolve => require(['../components/news-add'], resolve)
    },
    {
      path: '/news-list',
      component: resolve => require(['../components/news-list'], resolve)
    },
    {
      path: '/backnews-info',
      component: resolve => require(['../components/backnews-info'], resolve)
    },
    //移动端
    {
      path: '/mIndex',
      component: resolve => require(['../components/mobile/index'], resolve)
    },
    {
      path: '/mAbout',
      component: resolve => require(['../components/mobile/about'], resolve)
    },
    {
      path: '/mHealthy-fund',
      component: resolve => require(['../components/mobile/healthy-fund'], resolve)
    },
    {
      path: '/mFund',
      component: resolve => require(['../components/mobile/fund'], resolve)
    },
    {
      path: '/mNews',
      component: resolve => require(['../components/mobile/news'], resolve)
    },
    {
      path: '/mJob',
      component: resolve => require(['../components/mobile/job'], resolve)
    },
    {
      path: '/mNews-info',
      component: resolve => require(['../components/mobile/news-info'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js